module.exports = __webpack_public_path__ + "static/img/banner.860819f9.png";